import { Button, message } from 'antd'
import Rules from '../api/Rules'
import useFetchURL from '../elements/Hooks/useFetchURL'
import { isEmpty, get } from 'lodash'
import React, { useState } from 'react'

const rules = new Rules()

function OverrideActionButton(props) {
  const { company, doc, override, fetch } = props
  const [submitting, setSubmitting] = useState(false)

  const { data, fetching } = useFetchURL(
    `foxxapi/rules/override/${company}`,
    [company],
    isEmpty(company),
  )

  async function submit() {
    setSubmitting(true)
    try {
      const response = await rules.override({ _id: doc })
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  const isVisible = get(data, 'stamp', false)

  return (
    isVisible && (
      <Button
        style={{ marginTop: '10px' }}
        disabled={!!override}
        loading={submitting || fetching}
        onClick={() => submit()}
        type="primary">
        {!!override ? 'Override is Set' : 'Allow Override'}
      </Button>
    )
  )
}

export default OverrideActionButton
